import * as XLSX from "xlsx";

export const countLeadsFromFile = (file: File): Promise<number> => {
  return new Promise((resolve, reject) => {
    if (!file) {
      resolve(0);
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      if (!e.target?.result) return resolve(0);

      let filledLines = 0;

      if (file.name.endsWith(".csv")) {
        const text = e.target.result as string;
        const lines = text.split(/\r?\n/).slice(1);
        filledLines = lines.filter((line) => line.trim() !== "").length;
      } else if (file.name.endsWith(".xlsx")) {
        const data = new Uint8Array(e.target.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[firstSheetName];
        const json = XLSX.utils.sheet_to_json<any[]>(sheet, { header: 1 });
        filledLines = json
          .slice(1)
          .filter((row) =>
            row.some((cell) => cell !== "" && cell !== null),
          ).length;
      } else {
        return reject(new Error("Formato de arquivo não suportado"));
      }

      resolve(filledLines);
    };

    if (file.name.endsWith(".csv")) {
      reader.readAsText(file);
    } else if (file.name.endsWith(".xlsx")) {
      reader.readAsArrayBuffer(file);
    } else {
      reject(new Error("Formato de arquivo não suportado"));
    }
  });
};

export function extractApiErrorMessage(error: any): string {
  const axiosError = error?.response?.data?.error;
  const detail = error?.response?.data?.detail;

  if (typeof axiosError === "string") {
    return axiosError;
  }

  if (Array.isArray(detail) && detail.length > 0) {
    return detail[0].msg;
  }

  if (typeof detail === "string") {
    return detail;
  }

  return error?.message || "Erro ao processar requisição.";
}

export function stepCalculator(max: number, numTicks: number = 5) {
  const rawStep = max / numTicks;
  const magnitude = Math.pow(10, Math.floor(Math.log10(rawStep)));
  const step = Math.ceil(rawStep / magnitude) * magnitude;
  return step.toFixed(0);
}

export function getMaxRounded(value: number): number {
  if (value <= 10) return 10;

  const magnitude = Math.pow(10, Math.floor(Math.log10(value)));
  const rounded = Math.ceil(value / magnitude) * magnitude;
  return rounded;
}
